import { render, staticRenderFns } from "./NotesCard.vue?vue&type=template&id=79e7881d&"
import script from "./NotesCard.vue?vue&type=script&lang=ts&"
export * from "./NotesCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports